<template>
  <div class="container">
    <section class="top">
      <div class="header-wrapper">
        <div class="header">数据概览</div>
      </div>
      <div class="top-list">
        <template v-for="(item,index) in toplist" >
          <DataCard :item="item" :key="index" :index="index" :ismr="index>-1"></DataCard>
        </template>
      </div>
    </section>
    <section class="down">
      <article class="left">
        <div class="left-card left-card-one">
          <div class="header-wrapper">
            <div class="header">待办事项</div>
          </div>
          <div class="todo-list article-content">
            <template v-for="(item,index) in todoList" >
              <TodoCard :item="item" :key="index" :index="index" :showNumber="true" :isTodo="true"></TodoCard>
            </template>
          </div>
        </div>
        <div class="left-card left-card-two">
          <div class="header-wrapper justify-content-between">
              <div class="header">历史活动统计</div>
          </div>
          <div class="todo-list poin-rank article-content">
              <PlayHistory/>
          </div>
        </div>

        <div class="left-card left-card-three">
          <div class="left-card-three-left">
            <div class="header-wrapper justify-content-between">
              <div class="header">活动之星排行</div>
              <div class="more" @click="openDialog">查看更多<i class="el-icon-arrow-right" style="color:#A1A8B2"></i></div>
            </div>
            <div class="todo-list poin-rank article-content">
              <PointRank/>
            </div>
          </div>

          <div class="left-card-three-right">
            <div class="header-wrapper justify-content-between">
              <div class="header">热门活动排行</div>
              <div v-if="!isActivityApprove" class="more" @click="toPath(3)">查看更多<i class="el-icon-arrow-right" style="color:#A1A8B2"></i></div>
            </div>
            <div class="todo-list article-content ">
              <HotRank/>
            </div>
          </div>
        </div>
      </article>


      <article class="right">
        <div class="right-card">
          <div class="header-wrapper">
            <div class="header">常用功能</div>
          </div>
          <div class="todo-list article-content" >
            <template v-for="(item,index) in commonFun.slice(0,3)" >
              <TodoCard :item="item" :key="index" :index="index" :showNumber="false" ></TodoCard>
            </template>
          </div>
          <div class="divider"></div>
          <div class="todo-list article-content" >
            <template v-for="(item,index) in commonFun.slice(3)" >
              <TodoCard :item="item" :key="index" :index="index" :showNumber="false" :mt="true"></TodoCard>
            </template>
          </div>
        </div>
        <div class="right-card">
          <div class="header-wrapper justify-content-between">
            <div class="header">线上公告</div>
              <div v-if="!isBannerApprove" class="more" @click="toPath(1)">查看更多<i class="el-icon-arrow-right" style="color:#A1A8B2"></i></div>
            </div>
            <div class="todo-list article-content">
              <BannerBlock/>
            </div>
        </div>
        <div class="right-card">
          <div class="header-wrapper justify-content-between">
            <div class="header">线上文章</div>
              <div v-if="!isArticleApprove" class="more" @click="toPath(2)">查看更多<i class="el-icon-arrow-right" style="color:#A1A8B2"></i></div>
            </div>
            <div class="todo-list article-content">
              <ArticleBlock/>
            </div>
        </div>
      </article>
    </section>

    <Dialogs title="活动之星排名" :is-show-dialog="isShowPage" width="40%" @handleClick="handleClose">
      <div slot="content">
        <PointRank :showPagin="true" :key="Date.now()"/>
      </div>
      <div slot="btns" >
          <el-button v-if="hide" style="margin-right: 20px;">取 消</el-button>
          <el-button v-if="hide" type="primary" >保 存</el-button>
      </div>
    </Dialogs>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import {workbench} from '@/api/workBench'
import DataCard from './data-card.vue'
import TodoCard from './todo-card.vue'
import PointRank from './point-rank.vue'
import HotRank from './hot-rank.vue'
import PlayHistory from './play-history.vue'
import ArticleBlock from './article-block.vue'
import BannerBlock from './banner-block.vue'
import Dialogs from '@/components/page/Dialogs.vue'

export default{
  components: {
    DataCard,
    TodoCard,
    PointRank,
    HotRank,
    PlayHistory,
    ArticleBlock,
    BannerBlock,
    Dialogs
  },
  computed: {
    ...mapState({
      menuCodeSet: state => state.user.menuCodeSet
    })
  },
  data () {
    return {
      toplist: [],
      todoList: [],
      commonFun: [],
      isShowPage: false,
      hide: false,
      isBannerApprove: false,
      isArticleApprove: false,
      isActivityApprove: false
    }
  },
  mounted () {
    this.getWorkbench()
  },
  methods: {
    getWorkbench () {
      workbench().then(({success, data}) => {
        if (success) {
          const toplist = [
            {list: [
              {name: '青藤会员数量', value: data.qingtengNum}
            ]},
            {list: [
              {name: '会员数量', value: data.memberNum}
            ]},
            {list: [
              {name: '爱心回收单数', value: data.orderTotalNum}
            ]},
            {list: [
              {name: '举办活动总数量', value: data.activityNum}
            ]},
            {list: [
              {name: '活动参与总人数', value: data.activityUserNum}
            ]}
          ]
          const todoList = [
            {
              title: '回收待审批',
              num: data.approveOrderNum
            },
            {
              title: '回收待回收',
              num: data.receiveOrderNum
            },
            {
              title: '会员待审批',
              num: data.approveMemberNum
            },
            {
              title: '内容待审批',
              num: data.contentApproveNum
            },
            {
              title: '诉求待查看',
              num: data.approveAppealNum
            }
          ]
          this.toplist = toplist
          this.todoList = todoList
        }
      })
    },
    toPath (type) {
      const common = this.commonFun.find(c => c.sourceType === type)
      this.$router.push({ path: common.to })
    },
    openDialog () {
      this.isShowPage = true
    },
    cancel () {
      this.isShowPage = false
    },
    handleClose () {
      this.cancel()
    }
  },
  watch: {
    menuCodeSet: {
      handler (codes) {
        // 是否是运维内容
        this.isBannerApprove = !codes.includes('bannerList')
        this.isArticleApprove = !codes.includes('articleList')
        this.isActivityApprove = !codes.includes('activityList')

        this.commonFun = [
          {
            imgName: 'gggl.png',
            title: '公告管理',
            to: this.isBannerApprove ? '/management-system/bannerApproveList' : '/management-system/bannerList',
            sourceType: 1
          },
          {
            imgName: 'hy.png',
            title: '会员管理',
            to: '/management-system/memberManagement'
          },
          {
            imgName: 'wz.png',
            title: '文章管理',
            to: this.isArticleApprove ? '/management-system/articleApproveList' : '/management-system/articleList',
            sourceType: 2
          },
          {
            imgName: 'hd.png',
            title: '活动管理',
            to: this.isActivityApprove ? '/management-system/activityApproveList' : '/management-system/activityList',
            sourceType: 3
          },
          {
            imgName: 'hs.png',
            title: '回收管理',
            to: '/management-system/recyclingForm'
          },
          {
            imgName: 'sqgl.png',
            title: '诉求管理',
            to: '/management-system/appealList'
          }
        ]
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    width: 100%;
    height:100%;
    overflow: auto;
    padding: 20px;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    background-color: #eee;

    .top{
      padding: 20px;
      border-radius: 5px;
      // height: 18%;
      height: 210px;
      background-color: #fff;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      .top-list{
        flex:1;
        display: flex;
        justify-content: space-between;
      }
    }
    .down{
      height: calc(82% - 20px);
      box-sizing: border-box;
      display: flex;
      .left{
          width: 74.4%;
          // display: flex;
          // flex-direction: column;
         .left-card{
            margin-bottom: 20px;
            border-radius: 5px;
            &:last-child{
              margin-bottom: 0;
            }
         }
         .left-card-one{
            background-color: #fff;
            // height: 23%;
            height: 200px;
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            background: #fff;
            flex-direction: column;
            overflow: hidden;
         }
         .left-card-two{
            background-color: #fff;
            height: 37%;
            overflow: hidden;
            border-radius: 5px;
            padding: 20px;
            display: flex;
            flex-direction: column;
         }
         .left-card-three{
            // height: 33%;
            height:600px;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            overflow: hidden;
            .left-card-three-left{
              background-color: #fff;
              width: 30%;
              height: 100%;

              border-radius: 5px;
              padding: 20px;
              display: flex;
              flex-direction: column;
              .point-rank{
                height: 100%;
                width: 100%;
              }
            }
            .left-card-three-right{
              background-color: #fff;
              width: 70%;
              border-radius: 5px;
              height: 100%;
              border-radius: 5px;
              padding: 20px;
              display: flex;
              flex-direction: column;
              margin-left: 20px;
              .hot-rank{
                height: 100%;
                width: 100%;
              }
            }
         }
      }
      .right{
        margin-left: 20px;
        width: calc(25.6% - 20px);
        // display: flex;
        // flex-direction: column;
        .right-card{
          width: 100%;
          background-color: #fff;
          margin-bottom: 20px;
          border-radius: 5px;
          padding: 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          &:first-child{
            // height: 20%;
            height: 200px;
          }
          &:nth-child(2){
            height:37%;
          }
          &:last-child{
            // height:33%;
            height:580px;
            margin-bottom: 0;
          }
        }
      }
    }


    .header-wrapper{
        display: flex;
        align-items: center;
        height:20px;
        margin-bottom: 20px;
      }
    .header{
      font-family: MiSans;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 80px;
    }
    .word{
      font-family: MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #939393;
    }
    .more{
      font-family: MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #464C5E;
      cursor: pointer;
    }
    .todo-list{
      display: flex;
      background: #fff;
    }
    .justify-content-between{
      justify-content: space-between;
    }
    .flex-1{
      flex:1;
    }
    .article-content{
      height: calc(100% - 40px);
      width: 100%;
      overflow: hidden;
    }
    .divider{
      height:30px;
      width: 100%;
    }
  }
</style>

